import styled from 'styled-components';

export default styled.div`
  margin: 5em auto;
  font-size: 18px;
`;